export function isSupported(): boolean {
  const mediaSource = window.MediaSource;

  if (!mediaSource) {
    return false;
  }

  const isTypeSupported =
    typeof mediaSource.isTypeSupported === "function" &&
    mediaSource.isTypeSupported("video/mp4; codecs=\"avc1.42E01E,mp4a.40.2\"");

  const sourceBuffer = window.SourceBuffer;

  const sourceBufferValidAPI =
    !sourceBuffer ||
    (
      sourceBuffer.prototype &&
      typeof sourceBuffer.prototype.appendBuffer === "function" &&
      typeof sourceBuffer.prototype.remove === "function"
    );

  return isTypeSupported && sourceBufferValidAPI;
}
